import Mock from './Mock';

export default class ExpenseServiceMock {
  static getExpenseTypes() {
    return Mock.call();
  }

  static getExpenseByTimeEntryIdAndExpenseId() {
    return Mock.call();
  }

  static addExpense() {
    return Mock.call();
  }

  static deleteExpense() {
    return Mock.call();
  }

  static saveExpense() {
    return Mock.call();
  }
}
